function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Path Copy");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Designs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Corteva-Hub-Desktop",
  transform: "translate(-668.000000, -3652.000000)",
  fill: "#CCCCCC"
}, /*#__PURE__*/React.createElement("g", {
  id: "SW-Section",
  transform: "translate(0.000000, 2965.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Controller",
  transform: "translate(518.000000, 673.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Chapter",
  transform: "translate(90.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path-Copy",
  points: "60 3.5 61.6304 2 68 8 61.6304 14 60 12.5 64.8 8"
}))))));

var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/rightArrow.878965c8.svg";
export { SvgRightArrow as ReactComponent };